import { type FC } from "react";
import "./DashboardStates.scss";

interface DashboardErrorStateProps {
  message: string;
}

export const DashboardErrorState: FC<DashboardErrorStateProps> = ({
  message,
}) => {
  return (
    <div className="organic-tabs-dashboard__error" role="alert">
      {message}
    </div>
  );
};

export const DashboardLoadingSkeleton: FC = () => {
  return (
    <div className="dashboard-loading-skeleton" aria-hidden>
      <div className="dashboard-loading-skeleton__kpis">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="dashboard-loading-skeleton__block" />
        ))}
      </div>
      <div className="dashboard-loading-skeleton__panels">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="dashboard-loading-skeleton__block dashboard-loading-skeleton__block--panel"
          />
        ))}
      </div>
    </div>
  );
};
